export default __webpack_public_path__ + "static/montserrat-v15-latin-700italic-7c401449eb9dfe1eebb0e567fa32b562.ttf";